export enum Role {
  Owner = 'Owner',
  NestedOwner = 'NestedOwner',
  Proposer = 'Proposer',
  Executioner = 'Executioner',
  ModuleRole = 'ModuleRole',
  Recoverer = 'Recoverer',
  SpendingLimitBeneficiary = 'SpendingLimitBeneficiary',
  NoWalletConnected = 'NoWalletConnected',
}
